import React from 'react';
import { PortalProductImportModal } from './PortalProductImportModal';

interface Proposal {
  id: number;
  proposalName: string;
  proposalNumber: number;
  customerName: string;
  status: string;
  totalAmount: number;
  createdDate: string;
}

interface PortalImportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProductsImported?: () => void;
  preselectedProposalId?: number;
  preselectedProposal?: Proposal;
  placedProductIds?: string[];
  skipToProducts?: boolean;
}

export function PortalImportModal({
  isOpen,
  onClose,
  onProductsImported,
  preselectedProposalId,
  preselectedProposal,
  placedProductIds,
  skipToProducts,
}: PortalImportModalProps) {
  return (
    <PortalProductImportModal
      isOpen={isOpen}
      onClose={onClose}
      onProductsImported={onProductsImported}
      preselectedProposalId={preselectedProposalId}
      preselectedProposal={preselectedProposal}
      placedProductIds={placedProductIds}
      skipToProducts={skipToProducts}
    />
  );
}
